export const leftBarHidden = [
  '/inventory/add-stock',
  '/retailer/opening-balance',
  '/orders/counter-sale',
  '/orders/execute-order',
  '/orders/dispatch/',
  '/orders/new-counter-sale',
];
